import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export default function CountdownOverlay() {
  const [params] = useSearchParams();
  const [settings, setSettings] = useState(null);
  const solid = params.get("bg") === "dark";
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => setSettings({}));
  }, []);

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const target = params.get("to") || settings?.countdown_to || "2026-09-10T18:00:00+02:00";
  const labelParam = params.get("label");
  const label = labelParam !== null ? labelParam : (settings?.countdown_label ?? "WARDOGS — EARLY ACCESS");

  useEffect(() => {
    if (solid) return;
    const prevBody = document.body.style.background;
    const prevHtml = document.documentElement.style.background;
    document.body.style.setProperty("background", "transparent", "important");
    document.documentElement.style.setProperty("background", "transparent", "important");
    const appEl = document.querySelector(".App");
    const noiseEl = document.querySelector(".noise-overlay");
    const prevApp = appEl?.style.background || "";
    const prevNoise = noiseEl?.style.display || "";
    appEl?.style.setProperty("background", "transparent", "important");
    if (noiseEl) noiseEl.style.display = "none";
    return () => {
      document.body.style.background = prevBody;
      document.documentElement.style.background = prevHtml;
      if (appEl) appEl.style.background = prevApp;
      if (noiseEl) noiseEl.style.display = prevNoise;
    };
  }, [solid]);

  if (settings === null && !params.get("to")) return null;

  const diff = Math.max(0, new Date(target).getTime() - now);
  const cells = [
    ["giorni", Math.floor(diff / 86400000)],
    ["ore", Math.floor((diff / 3600000) % 24)],
    ["min", Math.floor((diff / 60000) % 60)],
    ["sec", Math.floor((diff / 1000) % 60)],
  ];

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center overflow-hidden ${solid ? "bg-[#050505]" : ""}`}
      data-testid="countdown-overlay"
    >
      {label && (
        <p className="font-mono text-[11px] md:text-sm uppercase tracking-[0.4em] text-wardogs mb-5" data-testid="countdown-label">
          {label}
        </p>
      )}
      <div className="flex items-start gap-2 md:gap-5">
        {cells.map(([key, v], i) => (
          <div key={key} className="flex items-start gap-2 md:gap-5">
            {i > 0 && <span className="font-display text-5xl md:text-8xl text-wardogs animate-blink leading-[0.85]">:</span>}
            <p
              className="font-display text-6xl md:text-9xl leading-[0.85] text-white text-center"
              style={{ textShadow: "0 0 32px rgba(255,106,0,0.4)" }}
              data-testid={`countdown-${key}`}
            >
              {String(v).padStart(2, "0")}
            </p>
          </div>
        ))}
      </div>
      {diff <= 0 && (
        <p className="font-display text-4xl md:text-5xl text-wardogs uppercase mt-6" data-testid="countdown-done">
          Disponibile ora
        </p>
      )}
    </div>
  );
}
